
import React from 'react';


export const attributes = {"name":"Invoices","order":9};
export default function() {
  return (
    <div>
      <h2>INVOICES</h2>
<p>Once an order has been approved and the guest arrival is confirmed, an invoice is created and can be synced with QuickBooks Online.</p>
<p><img src="/InvoicesView.JPG" alt="Invoices" title="Invoices" /></p>

    </div>
  );
};


// WEBPACK FOOTER //
// ../content/pages/data-and-record-types/record-types-explained/invoices.md